import React, { Component } from 'react';
import Helmet from 'react-helmet';

function getBoundingRect(_el) {
  const target = _el;
  let gleft = 0;
  let gtop = 0;
  let rect = {};

  const moonwalk = (_parent) => {
    if (_parent) {
      gleft += _parent.offsetLeft;
      gtop += _parent.offsetTop;
      moonwalk(_parent.offsetParent);
    } else {
      rect = {
        top: target.offsetTop + gtop,
        left: target.offsetLeft + gleft,
        bottom: target.offsetTop + gtop + target.offsetHeight,
        right: target.offsetLeft + gleft + target.offsetWidth,
      };
    }
  };
  moonwalk(target.offsetParent);
  return rect;
}

class IndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      splashProgress: 0,
    };
    this.adjustParallax = this.adjustParallax.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.adjustParallax);
    window.addEventListener('resize', this.adjustParallax);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.adjustParallax);
    window.removeEventListener('resize', this.adjustParallax);
  }

  adjustParallax() {
    const rect = getBoundingRect(this.splash);
    const scroll = window.scrollY;

    const splashProgress = Math.min(scroll / rect.bottom, 1);

    this.setState({
      splashProgress,
    });
  }

  render() {
    const { content } = this.props.pathContext;
    const pagetitle = content.pages.index.title;

    const meta = [];
    if (content.pages.index.description) {
      meta.push({ name: 'description', content: content.pages.index.description });
    }
    if (content.pages.index.keywords) {
      meta.push({ name: 'keywords', content: content.pages.index.keywords });
    }
    return (
      <div className="index-page">
        <Helmet title={`${pagetitle ? `${pagetitle} | ` : ''} ${content.title}`} meta={meta} />
        <div
          className="splash"
          ref={(e) => {
            this.splash = e;
          }}
          style={{
            backgroundPosition: `50% ${60 + this.state.splashProgress * 40}%`,
          }}
        >
          <div className="splash-container">
            <div className="splash-content">{content.pages.index.slogan}</div>
          </div>
        </div>
        <div className="content mainPage">
          <p className="title-p">{content.pages.index.text.first}</p>
          <div className="main-columns">
            <div className="first-column">
              <p>{content.pages.index.text.second}</p>
              <p className="strong-p">{content.pages.index.text.third}</p>
              <p>{content.pages.index.text.fourth}</p>
            </div>
            <div className="second-column">
              <img src="/building.min.jpg" alt="Centra ēka" />
            </div>
          </div>
          <div id="about">
            <h3>{content.pages.index.about.title}</h3>
            {content.pages.index.about.text.map((p, i) => <p key={i}>{p}</p>)}
            <div className="doctors">
              {content.pages.index.about.doctors.map((doctor, i) => (
                <p key={i}>
                  <strong>{doctor.name}</strong> {doctor.prof}
                  <span className="info">{doctor.info}</span>
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/imports/pages/main.jsx